import { RiArrowLeftSLine, RiArrowRightSLine } from '@remixicon/react'
import type { ReactNode } from 'react'
import { Link, useNavigate } from 'react-router-dom'

export interface BreadcrumbItem {
    label: string
    path: string
}

interface Props {
    title?: string
    subtitle?: string
    breadcrumbItems?: BreadcrumbItem[]
    badgeNode?: ReactNode
    children?: ReactNode
    showGoBack?: boolean
    onGoBack?: () => void
    actionsAlign?: 'center' | 'end'
    titleBadgeGap?: 'default' | 'tight'
}

export default function HeaderPageSection({
    title,
    subtitle,
    breadcrumbItems,
    badgeNode,
    children,
    showGoBack = true,
    onGoBack,
    actionsAlign = 'center',
    titleBadgeGap = 'default',
}: Props) {
    const navigate = useNavigate()

    return (
        <div className={`flex justify-between w-full ${actionsAlign === 'end' ? 'items-end' : 'items-center'}`}>
            <div className="flex flex-col">
                {breadcrumbItems && breadcrumbItems.length > 0 && (
                    <nav aria-label="Breadcrumb" className="mb-1">
                        <ol className="flex items-center gap-[2px] text-[16px] leading-[20px] text-[#475569]">
                            {breadcrumbItems.map((item, index) => (
                                <li key={index} className="flex items-center gap-[2px]">
                                    <Link
                                        to={item.path}
                                        className={`p-1 ${
                                            index === breadcrumbItems.length - 1
                                                ? 'font-semibold'
                                                : 'font-normal'
                                        }`}
                                    >
                                        {item.label}
                                    </Link>
                                    {index < breadcrumbItems.length - 1 && (
                                        <RiArrowRightSLine size={20} className="text-gray-400" />
                                    )}
                                </li>
                            ))}
                        </ol>
                    </nav>
                )}
                <div className="flex flex-col">
                    <div className={`text-[#070A13] text-[24px] font-semibold flex items-center leading-[28px] ${titleBadgeGap === 'tight' ? 'gap-1' : 'gap-4'}`}>
                        {showGoBack && (
                            <button
                                onClick={() => onGoBack ? onGoBack() : navigate(-1)}
                                className="text-gray-500 hover:text-gray-700 transition-colors"
                                aria-label="Atrás"
                            >
                                <RiArrowLeftSLine size={24} />
                            </button>
                        )}
                        {title && <h1>{title}</h1>}
                        {badgeNode && badgeNode}
                    </div>
                    {subtitle && (
                        <p className="text-[#667085] text-sm font-normal mt-1">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-4">{children}</div>
        </div>
    )
}
